<template>
    <div class="fw-home">

    </div>
</template>

<script>
    import {getCookie, getDeptId, getHomeActive, setCookie, setHomeActive} from "../../utils/auth";

    export default {
        components: {
        },
        data() {
            return {
                deptId: '',
            };
        },
        async created() {
            this.deptId = getDeptId()
        },
        methods: {
            async getSpmHomes() {
                let data = {
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getSpmHomes", data)
                this.homes = res.list
            },
            onSearch() {

            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-home {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
    }

</style>
